import React, { Component } from 'react';
import './App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Profile from './components/Profile';
import Match from './components/Match';

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = { expanded_hero: false, expanded_profile: false, match: false };
    }

    renderStartPage = () => {
        return (
            <div>
                <Hero
                    openProfile={() => this.setState({ expanded_profile: true })}
                    action={() => this.setState({ expanded_hero: !this.state.expanded_hero })}
                    isMatch={this.isMatch}
                />
                <Footer action={this.isMatch} />
            </div>
        );
    };

    isMatch = () => {
        this.setState({ match: !this.state.match });
    };

    render() {
        return (
            <div className="container">
                {this.state.expanded_hero ? null : (
                    <Header
                        open={() => this.setState({ expanded_profile: true })}
                        close={() => this.setState({ expanded_profile: false })}
                        profileIsOpen={this.state.expanded_profile}
                    />
                )}

                {this.state.expanded_profile ? <Profile /> : this.renderStartPage()}
                {this.state.match ? <Match action={this.isMatch} /> : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js